import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { BiPhone } from "react-icons/bi";
import { ImLocation2 } from "react-icons/im";
import "../assets/css/agent/left-bar.scss";
import { AiOutlineDownCircle, AiOutlineUpCircle, AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import { FaFilter } from "react-icons/fa";
import { Link } from "react-router-dom";
import Chat from "./Chat";

function LeftBar(props) {
    const { userId } = useParams();
    const [is_chat_open, setIsChatOpen] = useState(false);
    const [tickets_menu_is_open, setTicketsMenuIsOpen] = useState(false);
    const [interactions_menu_is_open, setInteractionsMenuIsOpen] = useState(false);
    const [activeCustomer, setActiveCustomer] = useState(null);

    useEffect(() => {
        var user_tabs = JSON.parse(localStorage.getItem("user_tabs"));
        var active_tab = user_tabs?.filter(t => t.id == userId);

        if (active_tab?.length) {
            setActiveCustomer(active_tab[0]);
        }
    }, [userId, localStorage.getItem("user_tabs")]);

    const onTicketsHeaderClicked = () => {
        setTicketsMenuIsOpen(!tickets_menu_is_open);
        setInteractionsMenuIsOpen(false);
    }

    const onInteractionsHeaderClicked = () => {
        setInteractionsMenuIsOpen(!interactions_menu_is_open);
        setTicketsMenuIsOpen(false);
    }

    return (
        <div className="left-bar">
            <div className="user-info">
                <div className="d-flex align-items-center mb-3">
                    <p className="user-name m-0">{activeCustomer?.name}</p>
                    <div className="package-type-div">
                        <p className="m-0">Premium</p>
                    </div>
                </div>
                <p className="mb-1 info">
                    <MdEmail
                        size={16}
                        className="me-1"
                    />
                    {activeCustomer?.email}
                </p>
                {/* <p className="mb-1 info">
                    <BiPhone
                        size={16}
                        className="mw-1"
                    />
                    +971 55 391 1212
                </p>
                <p className="mb-1 info">
                    <ImLocation2
                        size={16}
                        className="me-1"
                    />
                    asadnajam@gmail.com
                </p> */}
            </div>
            <div className="tickets-sidebar">
                <div
                    className="d-flex align-items-center justify-content-between header"
                    onClick={onTicketsHeaderClicked}
                >
                    <p className="m-0">Tickets</p>
                    {
                        tickets_menu_is_open ?
                            <AiOutlineUpCircle
                                size={20}
                            />
                            :
                            <AiOutlineDownCircle
                                size={20}
                            />
                    }
                </div>
                {
                    tickets_menu_is_open ?
                        <div className="body">
                            <div className="top-bar d-flex align-items-center justify-content-between">
                                <div className="search-div">
                                    <input type="text" className="form-control search-input" />
                                    <AiOutlineSearch
                                        className="search-icon"
                                    />
                                </div>
                                <div className="d-flex align-items-center">
                                    <FaFilter />
                                    <AiOutlineReload className="ms-2" />
                                </div>
                            </div>
                            <div className="tickets-section">
                                <Link
                                    className="ticket-link"
                                    to="/">
                                    <div className="ticket d-flex align-items-center justify-content-between">
                                        <div className="left">
                                            <p className="m-0 heading">Ticket#1234</p>
                                            <p className="m-0 description">Can you pls update my account details and give me the updated username and password</p>
                                        </div>
                                        <div className="right">
                                            <p className="time">2:35pm</p>
                                            <div className="type-box email-type">
                                                <p className="m-0 text-center">Email</p>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link
                                    className="ticket-link"
                                    to="/">
                                    <div className="ticket d-flex align-items-center justify-content-between">
                                        <div className="left">
                                            <p className="m-0 heading">Ticket#1234</p>
                                            <p className="m-0 description">Can you pls update my account details and give me the updated username and password</p>
                                        </div>
                                        <div className="right">
                                            <p className="time">2:35pm</p>
                                            <div className="type-box email-type">
                                                <p className="m-0 text-center">Email</p>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link
                                    className="ticket-link"
                                    to="/">
                                    <div className="ticket d-flex align-items-center justify-content-between">
                                        <div className="left">
                                            <p className="m-0 heading">Ticket#1234</p>
                                            <p className="m-0 description">Can you pls update my account details and give me the updated username and password</p>
                                        </div>
                                        <div className="right">
                                            <p className="time">2:35pm</p>
                                            <div className="type-box email-type">
                                                <p className="m-0 text-center">Email</p>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link
                                    className="ticket-link"
                                    to="/">
                                    <div className="ticket d-flex align-items-center justify-content-between">
                                        <div className="left">
                                            <p className="m-0 heading">Ticket#1234</p>
                                            <p className="m-0 description">Can you pls update my account details and give me the updated username and password</p>
                                        </div>
                                        <div className="right">
                                            <p className="time">2:35pm</p>
                                            <div className="type-box email-type">
                                                <p className="m-0 text-center">Email</p>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        :
                        <></>
                }
            </div>
            <div className="interactions-sidebar">
                <div
                    className="d-flex align-items-center justify-content-between header"
                    onClick={onInteractionsHeaderClicked}
                >
                    <p className="m-0">Interactions</p>
                    {
                        interactions_menu_is_open ?
                            <AiOutlineUpCircle
                                size={20}
                            />
                            :
                            <AiOutlineDownCircle
                                size={20}
                            />
                    }
                </div>
                {
                    interactions_menu_is_open ?
                        <div className="body">
                            <div className="top-bar d-flex align-items-center justify-content-end">
                                <FaFilter />
                                <AiOutlineReload className="ms-2" />
                            </div>
                            <div className="interactions-section">
                                <Link
                                    className="interaction-link"
                                    to="/">
                                    <div className="interaction d-flex">
                                        <div className="left">
                                            <div className="circle colored-circle"></div>
                                            <div className="line colored-line"></div>
                                        </div>
                                        <div className="right">
                                            <p className="m-0 heading">Bug fixed</p>
                                            <p className="m-0 time">Now</p>
                                        </div>
                                    </div>
                                </Link>
                                <Link
                                    className="interaction-link"
                                    to="/">
                                    <div className="interaction d-flex">
                                        <div className="left">
                                            <div className="circle colored-circle"></div>
                                            <div className="line colored-line"></div>
                                        </div>
                                        <div className="right">
                                            <p className="m-0 heading">Bug fixed</p>
                                            <p className="m-0 time">September 23, 2022</p>
                                        </div>
                                    </div>
                                </Link>
                                <Link
                                    className="interaction-link"
                                    to="/">
                                    <div className="interaction d-flex">
                                        <div className="left">
                                            <div className="circle"></div>
                                            <div className="line"></div>
                                        </div>
                                        <div className="right">
                                            <p className="m-0 heading">Bug fixed</p>
                                            <p className="m-0 time">September 23, 2022</p>
                                        </div>
                                    </div>
                                </Link>
                                <Link
                                    className="interaction-link"
                                    to="/">
                                    <div className="interaction d-flex">
                                        <div className="left">
                                            <div className="circle colored-circle"></div>
                                            <div className="line colored-line"></div>
                                        </div>
                                        <div className="right">
                                            <p className="m-0 heading">Bug fixed</p>
                                            <p className="m-0 time">September 23, 2022</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        :
                        <></>
                }
            </div>
            <div className="d-flex align-items-center bottom-row">
                <div>
                    <div className="call">
                        <p className="m-0">Call</p>
                    </div>
                </div>
                <div
                    style={{
                        position: "relative"
                    }}
                >
                    <div
                        className="live-chat"
                        onClick={() => setIsChatOpen(!is_chat_open)}
                    >
                        <p className="m-0">Live Chat</p>
                    </div>
                    {
                        is_chat_open ?
                            <Chat
                                minimizeChat={() => setIsChatOpen(false)}
                            />
                            :
                            <></>
                    }
                </div>
            </div>
        </div>
    )
}

export default LeftBar;